import React, { FC } from 'react';
import classNames from 'classnames';

type Props = {
  value: string;
  name: string;
  isSelected: boolean;
  handleClick: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export const RadioInput: FC<Props> = ({
  value,
  handleClick,
  name,
  children,
  isSelected,
}) => (
  <label className="search-filters-radio">
    <input
      type="radio"
      name={name}
      value={value}
      className="search-filters-radio__input"
      onClick={handleClick}
    />
    <i
      className={classNames('material-icons search-filters-radio__icon', {
        icons__radio_button_unchecked: !isSelected,
        icons__radio_button_checked: isSelected,
        'search-filters-radio__icon--selected': isSelected,
      })}
    />
    {children}
  </label>
);
